import { render, staticRenderFns } from "./autoRouterparent.vue?vue&type=template&id=0ba79576&scoped=true&"
import script from "./autoRouterparent.vue?vue&type=script&lang=js&"
export * from "./autoRouterparent.vue?vue&type=script&lang=js&"
import style0 from "./autoRouterparent.vue?vue&type=style&index=0&id=0ba79576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba79576",
  null
  
)

export default component.exports